/* eslint-disable rulesdir/mix-import-module-exports */
import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import analytics from 'redux-analytics';

import { track, storageSaveData } from '../helpers';
import { navigateToHash } from '../helpers/urlHashHelper';
import { getAbtestingTrackData } from '../helpers/tracking';
import { urlHashMiddleware, storageMiddleware } from './middleware';
import rootReducer from './rootReducer';
import { getUpcoming } from '@client/redux/modules/mylounge-legacy/selectors';
import { pushNotificationMiddleware } from '@client/helpers/pushNotification/middleware';
import { createMiddleware as abtestingMiddleware, getExperiments } from '@pegasus/abtesting';

// build a custom tracking middleware
// all redux events that have a meta property with analytics data will get
// tracked, see https://github.com/markdalgleish/redux-analytics for more info
// the track function just pushes the values into window.dataLayer
const tracking = analytics((event) => {
    if (event) {
        const { type, payload } = event;
        track(type, payload);
    }
});

const storage = storageMiddleware((data) => {
    if (data) {
        storageSaveData(data);
    }
});

const urlHash = urlHashMiddleware((data) => {
    if (data && window) {
        setTimeout(() => {
            navigateToHash(data.back, data.key);
        }, 100);
    }
});


export default function configureStore (initialState = {}, config = {}) {
    const notificationsEnabled = config.isEnabled && config.isEnabled('pushNotification');

    const abtesting = abtestingMiddleware({
        endpoint: '/mylounge-api/abtesting',
        onExperimentLoad: getAbtestingTrackData,
        initialExperiments: getExperiments(initialState)
    });

    const middleware = [thunk, abtesting, tracking, storage, urlHash];

    if (notificationsEnabled) {
        const { appdomainid: appdomainId } = config;

        const pushNotification = pushNotificationMiddleware({
            initialUpcoming: getUpcoming(initialState),
            appdomainId
        });

        middleware.push(pushNotification);
    }

    // https://github.com/zalmoxisus/redux-devtools-extension#12-advanced-store-setup
    let composeEhancers = compose;
    if (__DEV__ && typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
        composeEhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    }

    const enhancer = composeEhancers(applyMiddleware(...middleware));
    const store = createStore(rootReducer, initialState, enhancer);

    if (module.hot) {
        module.hot.accept('./rootReducer', () => {
            const nextRootReducer = require('./rootReducer').default;
            store.replaceReducer(nextRootReducer);
        });
    }

    return store;
}
